import { render, staticRenderFns } from "./SkillNew.vue?vue&type=template&id=252a0f4f"
import script from "./SkillNew.vue?vue&type=script&lang=js"
export * from "./SkillNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports